import LayerGroup from 'ol/layer/Group';
import ImageLayer from 'ol/layer/Image';
import { ImageWMS } from 'ol/source';
import React, { ReactElement, useEffect, useState } from 'react'
import { useAllWeatherContext } from '../../provider/AllWeatherProvider';
import { getGlobalLayer, LocationMarkerPopup } from '../MainWindow';
import { ecmf3hEnd, ecmf3hInterval, ecmf3hStart, ecmf6hEnd, ecmf6hInterval, ecmf6hStart, icon1hInterval,
  icon1hStart, layerStartDate } from '../../TimeLine/BackgroundMapTimeLine/TimeLineService';
import { ecmf, ICON } from '../weather/weatherLayer';
import { map } from '../MainLayer';

type JetStreamsPropsType = {
    name: string;
    color?: string;
    img?: ReactElement<any, any>;
    timeLineHour: string;
    timeLineDate: string;
    selectModel: string;
}

type LayerMapType = Map<string, ImageLayer<ImageWMS>>;
let layerMap: LayerMapType = new Map();

let isButtonClicked: boolean = false;
let jetStreamsMap: Map<string, ImageLayer<ImageWMS>> = new Map();
let jetStreamsIcon: Map<string, ImageLayer<ImageWMS>> = new Map();
let jetStreamsMapECMWF: Map<string, LayerMapType> = new Map();
let jetStreamsMapICON: Map<string, LayerMapType> = new Map();
let receivedLayer: string = "";
export let jetStreamsLayerGroup = new LayerGroup({});

const JetStreams = (props: JetStreamsPropsType) => {
    const {setJetStreams,jetStreams}=useAllWeatherContext();
    const [isSelected, setIsSelected] = useState<boolean>(false)

    const handleButtonClick = () => {
      isButtonClicked = false;
        //setIsSelected(prevState => !prevState)
        // LocationMarkerPopup("JetStreams");
        // if(!isSelected){
        //     setJetStreams("JetStreams")
        // }else{
        //     setJetStreams("JetStreamsNot")
        // }
    }

    useEffect(() => {jetStreamsIconClick();}, [isSelected]);
    
    useEffect(() => {}, [isButtonClicked]);

    useEffect(() => {
        if (jetStreams === "JetStreams") {
          isButtonClicked = true;
          jetStreamsIconClick();
        }
      }, [props.timeLineHour, props.timeLineDate]);
    
      function formatTimestamp(timestamp: number): string {
        const date = new Date(timestamp * 1000); // Multiply by 1000 to convert to milliseconds
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
        const day = String(date.getDate()).padStart(2, "0");
        const hour = String(date.getHours()).padStart(2, "0");
        const minute = String(date.getMinutes()).padStart(2, "0");
    
        return `${year}-${month}-${day}-${hour}:${minute}`;
      }
    
      function parseDateString(dateString: string): string | null {
        const offsetMinutes = new Date().getTimezoneOffset();
    
        const dateRegex = /^(\d{4})-(\d{2})-(\d{2})-(\d{2}):(\d{2})$/;
        const match = dateString.match(dateRegex);
        if (!match) {
          console.error("Invalid date format:", dateString);
          return null;
        }
        const [, year, month, day, hour, minute] = match;
        const date = new Date(
          Number(year),
          Number(month) - 1,
          Number(day),
          Number(hour),
          Number(minute)
        );
        date.setMinutes(date.getMinutes() + offsetMinutes);
        const formattedDate = `${date.getFullYear()}-${String(
          date.getMonth() + 1
        ).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}-${String(
          date.getHours()
        ).padStart(2, "0")}:${String(date.getMinutes()).padStart(2, "0")}`;
        return formattedDate;
      }
    
      const [isReady, setIsReady] = useState(false);
    
      useEffect(() => {
        if (ecmf6hStart && ecmf6hStart !== 0) {
          setIsReady(true); // Set ready state to true when ecmf6hStart is valid
        }
      }, [ecmf6hStart]);

      const date = new Date();
      const formattedDate = date.toLocaleDateString('en-CA');
    
      const resultMap = new Map<number, string>();
    
      useEffect(() => {
        if (!isReady) return;
        if (jetStreams === "JetStreams") {
      
          let i = 0;
          for (; i <= 48; i++) {
            const value = ecmf3hStart + i * ecmf3hInterval;
            if (value > ecmf3hEnd) break;
            resultMap.set(i, formatTimestamp(value));
          }
    
          for (let j = i; j <= 64; j++) {
            const value = ecmf6hStart + (j - 48) * ecmf6hInterval;
            if (value > ecmf6hEnd) break;
            resultMap.set(j, formatTimestamp(value));
          }
    
          try {
            for (let i = 0; i <= ecmf.size; i++) {
              let dateBefore = resultMap.get(i) ?? "";
              let dayPass = parseDateString(dateBefore);
    
              var layers = new ImageLayer({
                source: new ImageWMS({
                  url: "https://wms.tecxal.com/visura/weatherwmseagle",
                  params: {
                    LAYERS: `weather:${layerStartDate}_ecmwf_${dayPass}:00_temp`,
                    STYLES: "weather:temp",
                  },
                  serverType: "geoserver",
                  projection: "EPSG:4326",
                }),
              });
              layers.set("name", "JetStreams");
              const key = resultMap.get(i);
              if (key !== undefined) {
                jetStreamsMap.set(key, layers);
              }
              jetStreamMap("JetStreams", jetStreamsMap);
            }
          } catch (error) {
            console.error("Error fetching API data:", error);
          }
        } 
       // else if (weatherlayerState === "flood") {
        //   setIsClicked(false);
        //   LocationMarkerPopup("temperature");
        // } else {
        //   setIsClicked(false);
        // }
      }, [jetStreams, isReady]);

      const [isIconReady, setIconReady] = useState(false);
    
   useEffect(() => {
        if (icon1hStart && icon1hStart !== 0) {
          setIconReady(true);
        }
      }, [icon1hStart]);
    
   const resultIconMap = new Map<number, string>();
    
      useEffect(() => {
        if (!isIconReady) return;
        if (props.selectModel === "ICON") {
          let i = 0;
          for (; i <= 180; i++) {
             const value = icon1hStart + i * icon1hInterval;
            resultIconMap.set(i, formatTimestamp(value));
          }
    
          try {
            for (let i = 0; i <= ICON.size; i++) {
              let dateBefore = resultIconMap.get(i) ?? "";
              let dayPass = parseDateString(dateBefore);
              var layers = new ImageLayer({
                source: new ImageWMS({
                  url: "https://wms.tecxal.com/visura/weatherwmseagle",
                  params: {
                    LAYERS: `weather:2024-11-04_ecmwf_${dayPass}:00_temp`,
                    STYLES: "weather:temp",
                  },
                  serverType: "geoserver",
                  projection: "EPSG:4326",
                }),
              });
              layers.set("name", "JetStreams");
              const key = resultIconMap.get(i);
              if (key !== undefined) {
                jetStreamsIcon.set(key, layers);
              }
              jetStreamMapICON("JetStreams", jetStreamsIcon);
            }
          } catch (error) {
            console.error("Error fetching API data:", error);
          }
        }
      }, [props.selectModel, isIconReady]);
    
      const jetStreamsIconClick = () => {
        try {
          setTimeout(() => {
            let tempLayerMap;
            if (props.selectModel === "ECMWF") {
              tempLayerMap = jetStreamsMapECMWF.get("JetStreams");
            } else if (props.selectModel === "ICON") {
              tempLayerMap = jetStreamsMapICON.get("JetStreams");
            }
    
            if (tempLayerMap) {
              const layer = tempLayerMap.get(props.timeLineDate + "-" + props.timeLineHour);
              if (layer) {
                getGlobalLayer(layer);
                if (!isButtonClicked) {
                    // addExtremeWeatherLayerGroup(layer, isSelected, "Atmospheric Rivers");
                    jetStreamsLayer(layer, isSelected, "JetStreams");
                } else {
                   // addExtremeWeatherLayerGroup(layer, false, "Atmospheric Rivers");
                   jetStreamsLayer(layer, isSelected, "JetStreams");
                }
              }
            }
            // setWeatherLayer("temperature");
          }, 500);
        } catch (error) {
          console.error("Error fetching API data:", error);
        }
      };


    return (
        <div className={`subItemWrapper`} onClick={(e) => handleButtonClick()} onTouchStart={(e) => handleButtonClick()}>
            {props.color && (
                <div className={`colorBox ${isSelected ? 'selected' : ''}`} style={{backgroundColor: `${props.color}`}}></div>
            )}

            {props.img  && (
                <div className={`colorBox ${isSelected ? 'selected' : ''}`}>
                    {props.img}
                </div>
            )}
            <span>{props.name}</span>
            <div className={`hover-message`}>In progress</div>
        </div>
    )
}

export default JetStreams;

export function jetStreamMap(weatherLayerName:string,layerMap:LayerMapType){
    jetStreamsMapECMWF.set(weatherLayerName,layerMap);
}

export function jetStreamMapICON(
    weatherLayerName: string,
    layerMap: LayerMapType
  ) {
    jetStreamsMapICON.set(weatherLayerName, layerMap);
  }
  

export  function jetStreamsLayer (
    receivedWeatherLayer:  ImageLayer<ImageWMS>,
    isRemove: boolean,
    layerName: string
  ): LayerGroup {
    if (isRemove) {
      if (receivedLayer === layerName) {
        jetStreamsLayerGroup.getLayers().clear();
      } else {
        jetStreamsLayerGroup.getLayers().clear();
      }
      jetStreamsLayerGroup.getLayers().push(receivedWeatherLayer);
    //   setLayersvalue(layerName);
    //   getLayerName(layerName, true);
      receivedLayer = layerName;
    } else {
        jetStreamsLayerGroup.getLayers().forEach(function (layer) {
        if (layer.get("name") != undefined && layer.get("name") === layerName) {
            jetStreamsLayerGroup.getLayers().remove(layer);
            jetStreamsLayerGroup.getLayers().clear();
        }
      });
    //   getLayerName(layerName, false);
    }
    return jetStreamsLayerGroup;
  }

  map.addLayer(jetStreamsLayerGroup);